export interface TermsAccept {
  accept: boolean;
}

export interface TermsContent {
  type: string;
  status: TermsStatus;
  version: string;
  content: string;
  url: string;
}

export enum TermsStatus {
  Draft = 1,
  Removed = 2,
  Published = 3,
}
